//# sourceMappingURL=my-calendar-view-changed.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/mydatepicker/dist/interfaces/my-calendar-view-changed.interface.js
// module id = ./node_modules/mydatepicker/dist/interfaces/my-calendar-view-changed.interface.js
// module chunks = vendor